module.exports = __webpack_public_path__ + "static/media/icon-send.c1e0e16c.svg";